import { LogOutIcon, UserIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

import { Navigation } from 'apps/employer_dashboard/components/Navigation'
import { DashboardLayout } from 'shared/dashboard/Layout'
import { MobileNavMenu } from 'shared/dashboard/MobileNavMenu'
import { ProfileDropdown } from 'shared/dashboard/ProfileDropdown'
import { TextLink, useBreakpoint } from 'slab'
import { type DashboardEmployersContext } from 'utils/web_api.schemas'

interface AppLayoutProps {
  children?: React.ReactNode
  dashboardContext: DashboardEmployersContext
}

export function AppLayout ({ children, dashboardContext }: AppLayoutProps) {
  const { current_user: user, features } = dashboardContext
  const { breakpointIsAtLeast } = useBreakpoint()
  const navigate = useNavigate()

  const profileDropdown = (
    <ProfileDropdown name={user.full_name}>
      <ProfileDropdown.Item
        leftIcon={UserIcon}
        onSelect={() => navigate('/employers/dashboard/profile')}
      >
        Profile
      </ProfileDropdown.Item>
      <ProfileDropdown.Item
        leftIcon={LogOutIcon}
        onSelect={() => {
          // TODO: Implement logout endpoint
        }}
      >
        Logout
      </ProfileDropdown.Item>
      <ProfileDropdown.Section>
        <div className='px-4 py-2 body-sm text-gray-500 max-w-52'>
          Need help? Contact us at <TextLink href='mailto:support@thatch.com'>support@thatch.com</TextLink>
        </div>
      </ProfileDropdown.Section>
    </ProfileDropdown>
  )

  return (
    <DashboardLayout>
      {breakpointIsAtLeast('md')
        ? (
          <DashboardLayout.Sidebar>
            <div className='animate-in fade-in duration-150'>
              <div className='p-3 border-b border-gray-200'>
                {profileDropdown}
              </div>
              <Navigation features={features} />
            </div>
          </DashboardLayout.Sidebar>
          )
        : (
          <DashboardLayout.MobileNavBar>
            <div className='flex h-full justify-between'>
              <MobileNavMenu>
                <Navigation features={features} />
              </MobileNavMenu>
              <div className='p-4 flex items-center'>
                {profileDropdown}
              </div>
            </div>
          </DashboardLayout.MobileNavBar>
          )}
      <DashboardLayout.Main>
        <div className='grow flex flex-col animate-in fade-in duration-150'>
          {children}
        </div>
      </DashboardLayout.Main>
    </DashboardLayout>
  )
}
